module.exports = __webpack_public_path__ + "img/flags.a5ce846d.png";